// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascripts/chunks/" + {"462":"15b3e2cff9b7fa80e437","479":"01ae56cf418a5dc45814","791":"34f15e8f637c538804cd"}[chunkId] + "." + (chunkId === 479 ? "history-block-appp" : chunkId) + ".js";
};